import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type ValidatedStaffApplication = {
  applicationId: number
  staffId: number
}

export function validateStaffApplications(data: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.candidate.validate.url, null))
    .post<ValidatedStaffApplication[], IdsInput>(data)
}
